import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './home/home.component';
import { PimComponent } from './pim/pim.component';
import { AdminComponent } from './admin/admin.component';

const routes: Routes = [
  { path: 'home', canActivate: [MsalGuard], component: HomeComponent },
  { path: 'pim', canActivate: [MsalGuard], component: PimComponent },
  { path: 'admin', canActivate: [MsalGuard], component: AdminComponent },
  { path: '', redirectTo: '/home', pathMatch: 'full'},
  { path: '**', redirectTo: '/home'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, 
    {
      useHash: true,
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled'
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }